import {
  VERIFY_OTP_REQUEST,
  VERIFY_OTP_SUCCESS,
  VERIFY_OTP_FAILURE,
  RESET_VERIFY_OTP_STATE,
  RESEND_OTP_SUCCESS,
  SET_AUTH_DATA,
} from "../../actionTypes/otpValidation";

interface OtpState {
  loading: boolean;
  error: string | null | undefined;
  verified: boolean;
  tenantSelection: {
    selectionToken: string;
    tenants: Array<{
      tenantId: number;
      tenantName: string;
      tenantCode?: string;
      isPrimary?: boolean;
      role?: string;
    }>;
  } | null;
  auth: {
    accessToken: string | undefined;
    refreshToken: string | undefined;
    sessionId: string | undefined;
    activeRole?: string;
    availableRoles?: string[];
    user: {
      firstname: string | undefined;
      lastname: string | undefined;
    };
  }
}

const initialState: OtpState = {
  loading: false,
  error: null,
  verified: false,
  tenantSelection: null,
  auth: {
    accessToken: undefined,
    refreshToken: undefined,
    sessionId: undefined,
    user: {
      firstname: undefined,
      lastname: undefined,
    },
  },
};

export interface OtpAction {
  type: string;
  payload?: any;
}

const authDetails = (state = initialState, action: OtpAction): OtpState => {
  switch (action.type) {
    case VERIFY_OTP_REQUEST:
      return { ...state, loading: true, error: null, verified: false };
    case VERIFY_OTP_SUCCESS: {
      // OTP verified successfully - set verified to true
      // The payload is the BaseResponse, extract auth data if available
      const responseData = action.payload?.data || action.payload;
      return { 
        ...state, 
        loading: false, 
        verified: true,
        tenantSelection: responseData?.tenantSelectionRequired
          ? {
              selectionToken: responseData.selectionToken,
              tenants: responseData.tenants || [],
            }
          : null,
        auth: {
          accessToken: responseData?.accessToken || state.auth.accessToken,
          refreshToken: responseData?.refreshToken || state.auth.refreshToken,
          sessionId: responseData?.sessionId ?? state.auth.sessionId,
          activeRole: responseData?.activeRole ?? state.auth.activeRole,
          availableRoles: responseData?.availableRoles ?? state.auth.availableRoles,
          user: {
            firstname: responseData?.user?.firstname || state.auth.user?.firstname,
            lastname: responseData?.user?.lastname || state.auth.user?.lastname,
          },
        }
      };
    }
    case SET_AUTH_DATA:
      // Store auth data but DO NOT set verified=true - OTP must be verified first
      return { 
        ...state, 
        loading: false, 
        verified: false,
        auth: {
          accessToken: action.payload.accessToken,
          refreshToken: action.payload.refreshToken,
          sessionId: action.payload.sessionId ?? state.auth.sessionId,
          activeRole: action.payload.activeRole ?? state.auth.activeRole,
          availableRoles: action.payload.availableRoles ?? state.auth.availableRoles,
          user: action.payload.user || state.auth.user,
        }
      };
    case VERIFY_OTP_FAILURE:
      return { ...state, loading: false, error: action.payload };
    case RESET_VERIFY_OTP_STATE:
    case RESEND_OTP_SUCCESS:
      return initialState;
    default:
      return state;
  }
};

export default authDetails;
